import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../App';
import Hero from '../components/Hero';
import Maths from './Maths';

const Builders = ({setModal})=>{

	const {school} = useContext(AppContext);

	const [ show, setShow ] = useState(true);
	useEffect(()=>{
		let show = true;
		if (school.mathsLicense === "TERM" && school.mathsLicenseExpiry < new Date())
			show = false;
		if (school.mathsLicense === "PAGE" && school.mathsAvailableImpressions <= 0)
			show = false;

		setShow(show);
	}, [school.mathsLicenseExpiry, school.mathsLicense, school.mathsAvailableImpressions]);

	if (!show) {
		return <Hero>
			<div>Unfortunately your licence doesn't allow you to create any more PDF homework sheets at this time.  We'd love you to keep enjoying
				the homework sheets that we create, so please click on the renew button above to find out how!
			</div>

		</Hero>
	} else {
		return <Maths setModal={setModal}/>
	}
}

export default Builders;